<template>
    <van-popup v-model:show="show" position="right" :style="{
        minWidth: '100%',
        minHeight: '100%',
        background: 'green',
        color: '#fff',
        overflow: 'hidden',
    }">
        <div class="popupContainer">
            <van-row class="header">
                <van-col span="3" class="backIcon">
                    <img src="@/assets/common/backIcon.png" alt="" @click="close">
                </van-col>
                <van-col class="header_item_logo" span="8">
                    <img :src="dataSet?.mainHeader.url" v-if="dataSet?.mainHeader.display" alt="">
                </van-col>
                <van-col v-if="userStore.loginAccount" span="13" class="header_button_item" align="center">
                    <div v-if="dataSet?.depositButon.display" @click="goToDeposit" class="coin_btn"
                        :style="{ backgroundImage: dataSet?.depositButon.colorCode }">
                        <div>{{ dataSet?.balance }}</div>
                        <span>
                            <img src="@/assets/common/plus.png" alt="">
                        </span>
                    </div>
                    <div v-if="dataSet?.profileButtonData.display" class="avatar_btn">
                        <img src="@/assets/common/head_icon.jpg" alt="" @click="goToProfile">
                        <span class="more_img">
                            <img :src="dataSet?.profileButtonData.url" alt="">
                        </span>
                    </div>
                </van-col>
            </van-row>
            <div class="searchField">
                <van-field v-model="localValue" type="text" :placeholder="$t('home.searchGames')" class="custom-field">
                    <template #right-icon>
                        <div class="left-section">
                            <img src="@/assets/themeThree/search_icon.png" alt="" width="15%" style="opacity: 0.4;"
                                @click="searchGames">
                        </div>
                    </template>
                </van-field>
            </div>
            <van-row class="game_container">
                <van-col span="6" style="height: 80%;">
                    <div class="left_container" style="overflow-y: scroll;height: 80%;">
                        <div v-for="item in dataSet?.groupList" :key="item.id" class="game_menu_item"
                            :class="dataSet?.activeItem === item.id ? 'active_group' : ''" @click="selectGroup(item)">
                            <img :src="item.icon" alt="" />
                            <div class="groupText">{{ $t(item.name) }}</div>
                        </div>
                    </div>
                </van-col>
                <van-col span="18" class="rightSide">
                    <van-tabs v-model:active="active" ref="tabsRef" sticky :ellipsis="false" @click-tab="onClickTab">
                        <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="item.id" />
                    </van-tabs>
                    <div class="right_container" v-if="dataSet?.gameList?.length > 0">
                        <van-row>
                            <van-col span="8" class="game_item" v-for="(item, index) in dataSet?.gameList" :key="index">
                                <GameCard :gameImage="item.customIcon"
                                    @clickGameCard="goToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)"
                                    :gameTypeId="item.id" :gameIsFavorite="item.isFavorite"
                                    @update-game-categories="getGameTabData" />
                            </van-col>
                        </van-row>
                        <div v-if="dataSet?.gameList.length > 0">
                            <div v-if="dataSet.activeItem != 'fav'">
                                <div v-if="!dataSet?.loading && dataSet?.showLoadMore" class="load_more_btn"
                                    @click="loadMoreGame">
                                    {{ $t('common.loadMore') }}
                                    <img src="@/assets/common/loadMore.png" alt="">
                                </div>
                                <div v-if="dataSet?.loading" class="loading_btn" @click="loadMoreGame">
                                    <van-loading size="20" />
                                    {{ $t('common.loading') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else style="display: flex;justify-content: center;padding-top: 15%;">
                        <NoData />
                    </div>
                </van-col>

            </van-row>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount, PropType, watch } from 'vue'
import GameCard from './components/gameCard.vue'
import { useUserStore } from '@/stores/user'
import { GameData, TAB_LIST } from '@/view/game/supportScript';
import NoData from '../components/common/noData.vue';
const userStore = useUserStore()
const popoverRef = ref<HTMLElement | null>(null)
const triggerRef = ref<HTMLElement | null>(null)
const props = defineProps({
    dataSet: {
        type: Object as PropType<GameData>,
        required: true
    }
})
const active = ref(0);
const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const tabList = ref(TAB_LIST)
const tabsRef = ref();
const localValue = ref('')
const showPopover = computed({
    get: () => props.dataSet.showPopover,
    set: (val) => emits('update:showPopover', val)
})
const emits = defineEmits(['update:show', 'update:showPopover', 'open', 'close', 'goToProfile', 'selectGroup', 'loadMoreGame', 'goToDeposit', 'goToPlayGame', 'openRegisterPopup', 'searchGames', 'onClickTab', 'getGameTabData'])

const activeItemIcon = computed(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item?.icon;
});

const open = (id: number | string) => {
    emits('open', id)
}
const close = () => {
    active.value = 0
    emits('close')
}
const goToProfile = () => {
    emits('goToProfile')
}
const selectGroup = (item: any) => {
    emits('selectGroup', item)
}
const loadMoreGame = () => {
    emits('loadMoreGame')
}
const goToDeposit = () => {
    emits('goToDeposit')
}
const onClickTab = (value: any) => {
    active.value = value.name
    localValue.value = ''
    emits('onClickTab', value)
}
const getGameTabData = () => {
    if (active.value == 3) {
        emits('getGameTabData')
    }
}
const handleClickOutside = (event: MouseEvent) => {
    const popoverEl = popoverRef.value
    const triggerEl = triggerRef.value
    if (
        popoverEl &&
        !popoverEl.contains(event.target as Node) &&
        triggerEl &&
        !triggerEl.contains(event.target as Node)
    ) {
        showPopover.value = false
    }
}
const goToPlayGame = (ID: any, makerID: any, favorite: number, favId: any) => {
    let data = {
        id: ID,
        makerId: makerID,
        isFavorite: favorite,
        favId: favId

    }
    emits('goToPlayGame', data)
}
const searchGames = () => {
    active.value = 0
    emits('searchGames', localValue.value)
}
watch(() => props.dataSet.show, (newVal) => {
    if (newVal) {
        setTimeout(() => {
            tabsRef.value?.resize();
        }, 100);
    }
});
defineExpose({
    open,
})
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})
</script>
<style scoped>
:deep(.van-popover__content) {
    height: 500px;
    width: 220px;
    overflow-y: auto;
}

#groupListPop>>>.van-popover__content {
    background: #27190d !important;
    padding: 5px 0px !important;
}

#groupListPop>>>.van-popover__arrow {
    color: #27190df5 !important;
}

#groupListPop>>>.van-popover__content::-webkit-scrollbar {
    display: none;
}

.header {
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    font-weight: 700;
    padding: 10px 0;
    background-image: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 2px 4px 0px;
}

.header img {
    width: 35px;
}

.backIcon img {
    width: 15px;
    background: #ffffff17;
    padding: 10px;
    border-radius: 10px;
    opacity: 0.6;
}

.sec_header {
    /* background: #27190D; */
    color: #FFFFFF;
    font-size: 15px;
    text-align: center;
    font-weight: 700;
    padding: 10px 0;
}

.sec_header img {
    width: 35px;
}

.header_item_logo {
    display: flex;
    align-items: center;
    padding: 0;
}

.header_item_logo img {
    width: 120px;
}

.sec_header_item_logo {
    display: flex;
    align-items: center;
    padding: 0;
}

.sec_header_item_logo img {
    width: auto;
    height: 35px;
}

.head_text {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.header_button_item {
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: right;
}

.avatar_btn img {
    width: 25px;
    border-radius: 30px;
}

.more_img img {
    width: 12px;
    position: absolute;
    margin: 15px 0px 0px -12px;
}

.popupContainer {
    background: url('@/assets/main_bg.png');
    background-size: cover;
    background-repeat: repeat;
    width: 100%;
    height: 100vh;
    overflow: hidden;
}

.left_container {
    display: flex;
    flex-direction: column;
    padding: 5px;
    height: 100%;
    overflow-y: auto;
}

.searchField {
    justify-content: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
}

.searchField>>>.van-cell {
    padding: 5px 15px;
    font-size: 16px;
    align-items: center;
    background: rgb(33 22 0);
    border: 1px solid rgb(176 119 13 / 54%);
    width: 100%;
    border-radius: 10px;
}

.searchField>>>.van-field__control {
    font-size: 16px;
    font-weight: bold;
    color: #fff;
}

.searchField ::v-deep(.van-field__control::placeholder) {
    color: rgba(255, 255, 255, 0.4) !important;
    font-size: 16px !important;
    font-weight: 400;
    display: flex;
    align-items: center;
}

.game_menu_item {
    background: #81644833;
    border-radius: 13.5px;
    color: rgba(255, 255, 255, 0.85);
    border: 1px solid #5a4010;
    font-size: 16px;
    font-weight: 600;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 0 10px;
    width: 90%;
    padding: 10px 5%;
}

.game_menu_item img {
    width: 80%;
    height: 30px
}

.groupText {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    padding: 10px 0 0;
}

.coin_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    color: #12151A;
    /* background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%); */
    font-size: 15px;
    font-weight: 700;
    border-radius: 20px;
    padding: 2px 10px;
    margin-right: 5px;
    white-space: nowrap;
    overflow: hidden;
}

.menu_text_column {
    display: flex;
    align-items: center;
    justify-content: center;
}

.coin_btn div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.coin_btn img {
    width: 10px;
    padding-left: 5px;
}

.game_item {
    padding: 5px;
}

.right_container {
    padding-right: 10px;
    height: 100%;
    overflow-y: auto;
}

.rightSide {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.rightSide>>>.van-tabs__wrap {
    background: transparent;
}

.rightSide>>>.van-tabs__nav {
    background: transparent;
    padding: 0 0px;
}

.rightSide>>>.van-tab {
    color: rgba(255, 255, 255, 0.4);
    border-radius: 10px;
    font-size: 15px;
    margin: 0 3px;
    padding: 0 10px;
    min-width: 25%;
    line-height: 15px;
    height: 35px;
    border: 0.5px solid rgb(240, 168, 83, 0.25);
}

.rightSide>>>.van-tab.van-tab--active {
    color: #ffffff;
    background: rgb(240, 168, 83);
}

.rightSide>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}

:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;
    /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;
    /* Chrome, Safari, Edge */
}

.active_group {
    color: rgba(0, 0, 0, 0.85);
    background-image: linear-gradient(180deg, #f0cd97 0%, #F0A853 100%);
    font-weight: 700;
}

.active_group img {
    filter: brightness(0.8);
    opacity: 1
}

.game_container {
    flex: 1;
    display: flex;
    height: 100%;
    overflow: hidden;
}

.vertical-line {
    width: 4px;
    height: 90%;
    margin: 0 auto;
    background: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;

}

.left_container,
.right_container {
    height: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding-bottom: 220px;
}

.left_container::-webkit-scrollbar,
.right_container::-webkit-scrollbar {
    display: none;
}

.load_more_btn {
    font-size: 15px;
    background: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.65);
    border-radius: 20px;
    padding: 10px 25px;
    display: flex;
    justify-content: center;
    margin: 10px 65px;

}

.load_more_btn img {
    width: 15px;
    opacity: 0.5;
    margin-left: 10px;
}

.loading_btn {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 25px;
    margin: 5px 65px;
}

.loading_btn>>>.van-loading {
    padding: 0 10px;
}

.menu_icon_column img {
    width: auto;
    height: 35px;
}

@media (max-width: 450px) {
    .load_more_btn {
        font-size: 13px;
    }

    .rightSide>>>.van-tab {
        font-size: 13px;
    }

    .searchField>>>.van-cell,
    .searchField ::v-deep(.van-field__control::placeholder),
    .searchField>>>.van-field__control {
        font-size: 13px !important;
    }
}
</style>